export const RECEIPT_ROUTING = [
    {
        path: '/receipt',
        name: 'receipt',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Phiếu xuất kho', pathName: 'receipt', icon: 'fa fa-file-code-o' },
            ]
        },
        component: () => import('./Receipt.vue'),
        redirect: { name: 'receipt-index' },
        children: [
            { 
                path: '/phieu-xuat-kho.html',
                name: 'receipt-index',
                component: () => import('./components/main-receipt/MainReceipt.vue')
            },
        ]
    }
];